import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface GatewayInfo {
  gateway_name: string
  created_on: string
  description: string
  image: string
  site_id?: string
  parent_asset_id?: string
  communication_protocol_id?: string
  communication_protocol_name?: string
}

export interface GatewayInfoState {
  isLoading: boolean
  loadingError: string | null
  gatewayInfo: GatewayInfo | null
  httpStatus: number | null
}

export const initialState: GatewayInfoState = {
  isLoading: true,
  loadingError: null,
  gatewayInfo: null,
  httpStatus: null
}

const gatewayInfoSlice = createSlice({
  name: 'deviceManagementGatewayInfo',
  initialState,
  reducers: {
    gatewayInfoLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        gatewayInfo: null,
        httpStatus: 0
      }
    },
    gatewayInfoUpdateAction: (state, action: PayloadAction<{ data: GatewayInfo, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        gatewayInfo: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    gatewayInfoErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        gatewayInfo: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  gatewayInfoLoadingAction,
  gatewayInfoUpdateAction,
  gatewayInfoErrorAction
} = gatewayInfoSlice.actions

export default gatewayInfoSlice.reducer
